export default defineNuxtRouteMiddleware(() => {
  useAppStore().setLoading(false);
});
